import { render } from "./ErrorModal.vue?vue&type=template&id=6ab3f906&scoped=true"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=6ab3f906&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab3f906"]])

export default __exports__